import { MONTHS, MONTHS_STRING, QUARTERS } from 'helper/const';

const lowerYear = val => (val ? val.toLowerCase() : '');
export const NORMAL_FIELDS = ['number'];
export const FILE_FIELDS = [
  'documents.or_permit_current_year',
  'documents.or_permit_previous_years',
  ...MONTHS_STRING.map(
    y => `documents.quarterly_${lowerYear(y)}_return_current_year`
  ),
  ...MONTHS_STRING.map(
    y => `documents.quarterly_${lowerYear(y)}_receipt_current_year`
  ),
  ...MONTHS_STRING.map(
    y => `documents.quarterly_${lowerYear(y)}_return_previous_year`
  ),
  ...MONTHS_STRING.map(
    y => `documents.quarterly_${lowerYear(y)}_receipt_previous_year`
  ),
];
export const NULL_FIELDS = [];
export const NUMBER_FIELDS = ['number'];
export const DATE_FIELDS = ['expiration_date'];
export const BODY_REQUEST_NORMAL_FIELDS = [];
export const PORTAL_FIELDS = ['username', 'password'];
// Fields for view mode
export const PROFILE_OBJ_KEYS = [
  {
    label: 'OR Permit Number',
    key: 'number',
    type: 'value',
  },
];
export const PERMIT_OBJ_KEYS = year => {
  return [
    {
      label: 'OR Permit',
      key: `year_wise.${year}.documents.or_permit_year_wise[0]`,
      type: 'file',
      isSingleFile: true,
    },
  ];
};
export const PERMIT1_OBJ_KEYS = year => {
  const returnArr = [];
  MONTHS.forEach(obj => {
    returnArr.push({
      label: `${obj.label} Return`,
      key: `year_wise.${year}.documents.quarterly_${obj.value}_return_year_wise[0]`,
      type: 'file',
      isSingleFile: true,
    });
    returnArr.push({
      label: `${obj.label} Receipt`,
      key: `year_wise.${year}.documents.quarterly_${obj.value}_receipt_year_wise[0]`,
      type: 'file',
      isSingleFile: true,
    });
  });
  return returnArr;
};
export const PERMIT2_OBJ_KEYS = year => {
  const returnArr = [];
  QUARTERS.forEach(obj => {
    returnArr.push({
      label: `${obj.label} Return`,
      key: `year_wise.${year}.documents.or_q${obj.value}_return_year_wise[0]`,
      type: 'file',
      isSingleFile: true,
    });
    returnArr.push({
      label: `${obj.label} Receipt`,
      key: `year_wise.${year}.documents.or_q${obj.value}_receipt_year_wise[0]`,
      type: 'file',
      isSingleFile: true,
    });
  });
  return returnArr;
};
const CURRENT_YEAR_OBJ_KEYS = [];
const PREVIOUS_YEAR_OBJ_KEYS = [];
MONTHS_STRING.map(y => {
  CURRENT_YEAR_OBJ_KEYS.push({
    label: `${y} Return`,
    key: `documents.quarterly_${lowerYear(y)}_return_current_year`,
    type: 'file',
    isSingleFile: true,
  });
  CURRENT_YEAR_OBJ_KEYS.push({
    label: `${y} Receipt`,
    key: `documents.quarterly_${lowerYear(y)}_receipt_current_year`,
    type: 'file',
    isSingleFile: true,
  });
  PREVIOUS_YEAR_OBJ_KEYS.push({
    label: `${y} Return`,
    key: `documents.quarterly_${lowerYear(y)}_return_previous_year`,
    type: 'file',
    isSingleFile: true,
  });
  PREVIOUS_YEAR_OBJ_KEYS.push({
    label: `${y} Receipt`,
    key: `documents.quarterly_${lowerYear(y)}_receipt_previous_year`,
    type: 'file',
    isSingleFile: true,
  });
  return true;
});
export { CURRENT_YEAR_OBJ_KEYS, PREVIOUS_YEAR_OBJ_KEYS };
